export const alertConstants = {
  POPUP_OPTIONS_PAIEMENT: 'POPUP_OPTIONS_PAIEMENT',
  ALERT: 'ALERT',
  SUCCESS: 'ALERT_SUCCESS',
  ERROR: 'ALERT_ERROR',
  CLEAR: 'ALERT_CLEAR',
};
